import React from "react";

export default function Footer() {
  return (
    <footer className="border-t border-[var(--ff-border)] mt-32 bg-[var(--ff-bg)]" data-testid="footer">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12 py-16 grid md:grid-cols-5 gap-12">
        <div className="md:col-span-2">
          <div className="font-display text-3xl mb-4">FRESHY FRESH<br/>PRODUCTIONS LLC</div>
          <div className="text-[var(--ff-text-dim)] text-sm max-w-md leading-relaxed">
            A multi-brand production network spanning music, film, broadcast, and digital media.
          </div>
        </div>
        <div>
          <div className="label-eyebrow mb-4">Company</div>
          <ul className="space-y-2 text-sm">
            <li><a href="/about" className="hover:text-[var(--ff-red)]">About</a></li>
            <li><a href="/team" className="hover:text-[var(--ff-red)]">Team</a></li>
            <li><a href="/departments" className="hover:text-[var(--ff-red)]">Departments</a></li>
            <li><a href="/careers" className="hover:text-[var(--ff-red)]">Careers</a></li>
          </ul>
        </div>
        <div>
          <div className="label-eyebrow mb-4">Network</div>
          <ul className="space-y-2 text-sm">
            <li><a href="/schedule" className="hover:text-[var(--ff-red)]">Show Schedule</a></li>
            <li><a href="/hr-investigations" className="hover:text-[var(--ff-red)]">HR Disclosures</a></li>
            <li><a href="/login" className="hover:text-[var(--ff-red)]">Sign In</a></li>
          </ul>
        </div>
        <div>
          <div className="label-eyebrow mb-4">Legal</div>
          <ul className="space-y-2 text-sm">
            <li><a href="/terms" className="hover:text-[var(--ff-red)]" data-testid="footer-terms-link">Terms of Service</a></li>
            <li><a href="/privacy" className="hover:text-[var(--ff-red)]" data-testid="footer-privacy-link">Privacy Policy</a></li>
            <li><a href="/policies" className="hover:text-[var(--ff-red)]" data-testid="footer-policies-link">Company Policies</a></li>
            <li><a href="/banned" className="hover:text-[var(--ff-red)]">Ban Appeals</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[var(--ff-border)]">
        <div className="max-w-[1600px] mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row justify-between text-xs text-[var(--ff-text-dim)] font-mono-ui">
          <div>© {new Date().getFullYear()} Freshy Fresh Productions LLC. All rights reserved.</div>
          <div className="uppercase tracking-[0.2em] mt-2 md:mt-0">FF–NETWORK / EST. 2026</div>
        </div>
      </div>
    </footer>
  );
}
